import Auth from './auth.js';
import Fuse from './fuse.js';
import ElasticLoader from './elasticLoader.js';
import SummaryLoader from './summaryLoader.js';
import OAuthHeaders from './oauthHeaders.js';
import ConfirmDelete from './confirmDelete.js';
import ConfirmDeleteSweet from './confirmDeleteSweet.js';
import simpleCRUD from './simpleCRUD.js';
import CrudCtrl from './crudctrl.js';
import UIMessages from './uimessages.js';
import LaravelTranslate from './laravelTranslate.js';
import Locales from './locales.js';
import LanguageLoader from './languageLoader.js';
import modalCRUD from './modalCRUD.js';
import AskAPI from './askAPI.js';
import stateChangeError from './stateChangeErrorService.js';
import Currencies from './currencies.js';
import APIPath from './apiPathInterceptor.js';
import sortable from './sortable.js';
import TipStore from './tipStore.js';
import ValidationRules from './LaravelValidationRules.js';
import ErrorReporter from './ErrorReporter.js';
import Facebook from './facebook.js';
import GTM from './googleTagManager.js';
import VisitorData from './visitorData.js';
import Intercom from './intercom.js';
import StripeSDK from './StripeSDK.js';
import SafariCacheBuster from './safariCacheBuster';
import Countries from './countries';
import beforeUnload from './beforeUnload.js';
import RelationAPI from './relationAPI.js';
import Highlighter from './highlighter.js';
import helpers from './helpers.js';
import WhitelabelTemplateOverrides from './whitelabelTemplateOverrides';
import syncHttp from './syncHttp';
import SeatsIO from './SeatsIO';
import ShopAnalytics from './ShopAnalytics';
import LibraryLoader from './libraryLoader.js';
import CSVExport from './csvExport.js';
import EventixSocket from './EventixSocket';
import ErrorRejector from './errorRejector';
import ScannerLoginModal from './scannerLoginModal';

export default angular.module('eventix.common.services', [
    helpers,
    Highlighter,
    Auth,
    Countries,
    syncHttp,
    LibraryLoader,
    OAuthHeaders,
    ConfirmDelete,
    ConfirmDeleteSweet,
    WhitelabelTemplateOverrides,
    simpleCRUD,
    CrudCtrl,
    TipStore,
    SafariCacheBuster,
    ElasticLoader,
    RelationAPI,
    SummaryLoader,
    UIMessages,
    LaravelTranslate,
    Locales,
    VisitorData,
    LanguageLoader,
    modalCRUD,
    AskAPI,
    Fuse,
    sortable,
    Currencies,
    stateChangeError,
    ValidationRules,
    StripeSDK,
    beforeUnload,
    APIPath,
    ErrorReporter,
    Facebook,
    GTM,
    Intercom,
    SeatsIO,
    ShopAnalytics,
    CSVExport,
    EventixSocket,
    ErrorRejector,
    ScannerLoginModal
]).name;
